import { THEME_NAME } from "./theme";

import { buildTheme } from "themes/themeBuilder";
import { commonColors, themesColors } from "themes/colorVariables";

export const getTheme = (themeName: THEME_NAME) => {
  const palette = {
    primary: {
      main: themesColors[themeName].primary,
      dark: themesColors[themeName].primaryDark,
    },
    error: {
      main: commonColors.red,
    },
  };
  return buildTheme(palette);
};
